<ul
  [class.show-description]="(isXs$|async)===false && (showDescriptionPreview$|async)"
  class="list-group mt-4">

  <ng-container #itemsContainer></ng-container>

  <!--<ng-template
    ngFor
    [ngForOf]="selectedProducts"
    let-product
    [ngForTrackBy]="trackByFn">

    <li class="product-item-group">
      <app-product-list-item
        [path]="product?.path"
        [queryParams]="category ? {category: category.id}:null"
        [product]="(product.id|getProductById)|ngrxPush">
      </app-product-list-item>
    </li>

  </ng-template>

  <ng-container *ngIf="listMode === 'preview'">

    <li class="product-item-group link-item">
      <a [routerLink]="['/', 'categories', category.id]"
        class="d-flex flex-fill align-items-center justify-content-center">
        <span>Voir les {{products.length}} produits</span>
      </a>
    </li>

  </ng-container>-->

</ul>

<ng-template #productListItem let-product="product">

  <li class="product-item-group">
    <app-product-list-item
      (productClick)="productClick.emit()"
      [path]="product?.path"
      [product]="(product.id|getProductById)|ngrxPush">
    </app-product-list-item>
  </li>

</ng-template>

<ng-template #previewLastListItem>

  <li class="product-item-group link-item">
    <a [routerLink]="['/', 'categories', category.id]"
       class="d-flex flex-fill flex-column align-items-center justify-content-center px-3">
      <span class="body-2 text-center">Voir tous les produits {{category.title}}</span>
      <span class="mat-headline font-weight-bold">+{{products.length - 3}}</span>
    </a>
  </li>

</ng-template>
